import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TitleBar from "../Layout/titleBar";
import MyDialog from "../Layout/myDialog";
import { Row, Col } from "react-flexbox-grid";
import Item from "./itemMarca";
import { sagaGetMarcas } from "../../reducers/marcasReducer/actions";
import "./marcas.css";
import Pagination from "../Layout/pagination";

const MarcaListado = (props) => {
  const { marcas, mapToItem } = props;

  const [itemsMarcas, setItemsMarcas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  React.useEffect(() => {
    const safeMarcas = Array.isArray(marcas) ? marcas : [];
    setItemsMarcas(
      safeMarcas.map((x) => ({
        idMarca: x.idMarca,
        nombre: x.nombre,
        codigo: x.codigo,
        opciones: mapToItem(x).opciones,
      }))
    );
    setCurrentPage(1);
  }, [marcas, mapToItem]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (nombre) => {
    props.handleOnSearch(nombre);
    setCurrentPage(1);
  };

  // Elementos en página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = itemsMarcas.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <TitleBar
        title={"Marcas"}
        handleOnSearch={handleSearch}
        searchPlaceholder="Marca"
        showSearch={true}
        newButtonLink="/Marcas/Edit/0"
        validator="nombreynumeros"
      />

      <Row style={{ margin: "0px" }} className="draggable">
        {currentItems &&
          currentItems.map((item, index) => (
            <Col md={6} lg={4} key={index} className="draggable">
              <Item item={item} {...props} />
            </Col>
          ))}
      </Row>

      {(props.marcas === undefined || props.marcas.length === 0) && (
        <div className="noMarcas">No se encontraron marcas.</div>
      )}

      {props.openModal && (
        <MyDialog
          cuerpo={props.mensaje}
          botonConfirmar={props.labelModalOk}
          handleOnConfirmar={() => {
            props.handleModalOk();
            setTimeout(props.handleOnSearch, 600);
          }}
          handleOnCancelar={props.handleCloseModal}
        />
      )}

      {/* Paginación */}
      {itemsMarcas.length > itemsPerPage && (
        <Pagination
          handleOnChange={handlePageChange}
          page={currentPage}
          totalPages={Math.ceil(itemsMarcas.length / itemsPerPage)}
        />
      )}
    </>
  );
};

MarcaListado.propTypes = {
  marcas: PropTypes.array.isRequired,
  handleOnSearch: PropTypes.func.isRequired,
  mensaje: PropTypes.string,
  labelModalOk: PropTypes.string,
  handleModalOk: PropTypes.func,
  handleCloseModal: PropTypes.func,
  openModal: PropTypes.bool,
};

MarcaListado.defaultProps = {
  marcas: [],
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetMarcas,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(MarcaListado);
